const firebaseConfig = {
  apiKey: "AIzaSyDZYSejT992b3_tALxr24NWrXWvHftSm0A",
  authDomain: "health-care-2615d.firebaseapp.com",
  projectId: "health-care-2615d",
  storageBucket: "health-care-2615d.appspot.com",
  messagingSenderId: "1088278445614",
  appId: "1:1088278445614:web:d2011c5bb4a30710e2e9bf"
};

  export default firebaseConfig;